<template>
  <a-modal
    v-model="visible"
    :title="modalTitle"
    :maskClosable="false"
    :closable="!formLoading"
    :okText="$t('com_btn_save')"
    @ok="formSubmit"
    @cancel="formReset"
    :confirmLoading="formLoading"
    :cancelButtonProps="{
      props: {
        disabled: formLoading,
      },
    }"
    :width="660"
    centered
  >
    <a-form-model
      :model="form"
      :rules="formRules"
      ref="formElement"
      :label-col="{ span: 7 }"
      :wrapper-col="{ span: 14 }"
    >
      <!-- 名称 -->
      <a-form-model-item :label="$t('configModel_form_item_name')" prop="name">
        <a-input
          v-model="form.name"
          :placeholder="$t('configModel_form_item_name_placeholder')"
          allowClear
          @input="formInput"
          ref="addFormName"
        />
      </a-form-model-item>

      <!-- 组别 -->
      <a-form-model-item :label="$t('configModel_form_group_name')" prop="groupId">
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="form.groupId"
          show-search
          :placeholder="$t('configModel_form_group_name_placeholder')"
          style="width:170px"
          :filter-option="
            (input, option) => {
              return (
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            }
          "
        >
          <a-select-option v-for="group in groupList" :key="group.groupId" :value="group.groupId">
            {{ group.groupName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 值类型 -->
      <a-form-model-item :label="$t('configModel_form_item_type')" prop="dataType">
        <a-select
          v-model="form.dataType"
          show-search
          :placeholder="$t('configModel_form_item_type_placeholder')"
          style="width:170px"
          @change="itemTypeChange"
          :filter-option="
            (input, option) => {
              return (
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            }
          "
        >
          <a-select-option v-for="type in itemTypes" :key="type.value" :value="type.value">
            {{ type.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <!-- 范围：枚举类型 -->
      <a-form-model-item
        :label="$t('configModel_form_item_data_range')"
        prop="dataRange"
        :extra="currentItemType && currentItemType.help"
      >
        <a-textarea
          v-model="form.dataRange"
          :placeholder="$t('configModel_form_item_data_range_placeholder')"
          :rows="5"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>

      <!-- 单位 -->
      <a-form-model-item :label="$t('configModel_form_item_unit')" prop="dataUnit">
        <a-input
          v-model="form.dataUnit"
          :placeholder="$t('configModel_form_item_unit_placeholder')"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>

      <!-- 描述 -->
      <a-form-model-item :label="$t('com_form_description')" prop="description" style="margin:0">
        <a-textarea
          v-model="form.description"
          :placeholder="$t('com_form_description_placeholder')"
          :rows="6"
          allowClear
          @input="formInput"
        />
      </a-form-model-item>
    </a-form-model>
    <!-- 错误描述 -->
    <div class="form-error-text" ref="formError">
      <Icon type="error" v-if="formError" />
      <p>{{ formError }}</p>
    </div>
  </a-modal>
</template>
<script>
import * as API from '@/api/system/config';
import itemTypes from '@/libs/itemTypes';
import { trim } from '@/libs/utils';

export default {
  props: {
    groupList: {
      type: Array,
      default: () => [],
    },

    callback: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      currentItemType: null,
      itemTypes: [...itemTypes.array],

      // 新增
      visible: false,
      formRules: {
        name: [
          {
            required: true,
            message: this.$t('configModel_form_item_name_placeholder'),
          },
        ],
        groupId: [
          {
            required: true,
            message: this.$t('configModel_form_group_name_placeholder'),
          },
        ],
        dataType: [
          {
            required: true,
            message: this.$t('configModel_form_item_type_placeholder'),
          },
        ],

        dataRange: [
          {
            validator: this.dataRangeValidator,
          },
        ],
      },

      // 搜索
      form: {
        dataRange: undefined,
        dataType: undefined,
        dataUnit: undefined,
        description: undefined,
        groupId: undefined,
        name: undefined,
        dictId: undefined,
      },

      formError: '',
      formIsEdit: '',
      formLoading: false,
      formFork: false,
    };
  },
  computed: {
    modalTitle() {
      if (this.formIsEdit) {
        return this.$t('configModel_item_edit_title');
      } else {
        if (this.formFork) {
          return this.$t('configModel_item_fork_title');
        } else {
          return this.$t('configModel_item_add_title');
        }
      }
    },
  },
  methods: {
    // 更新列表
    updateList() {
      // 更新列表
      this.callback();
    },

    // 显示
    show(currentGroup, record, fork) {
      this.visible = true;
      this.formIsEdit = record && !fork ? true : false;
      this.formFork = fork;

      // focus name
      this.$nextTick(() => {
        this.formReset();
        if (record) {
          Object.keys(this.form).forEach(key => {
            this.form[key] = record[key];
          });

          // 值类型
          this.itemTypeChange(record.dataType, true);
        } else {
          this.$refs.addFormName && this.$refs.addFormName.focus();
          this.currentItemType = undefined;
          this.form.groupId = currentGroup.groupId;
        }
      });
    },

    // 提交
    formSubmit() {
      this.$refs.formElement.validate(valid => {
        if (valid) {
          this.formLoading = true;

          if (this.formIsEdit) {
            // 编辑
            API.ConfigItemEdit(this.form)
              .then(res => {
                if (res.code === 0) {
                  // this.$message.success(this.$t('com_msg_edit_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                  this.$refs.formError.scrollIntoView(true);
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          } else {
            // 添加
            API.ConfigItemSave(this.form)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success(this.$t('com_msg_add_success'));
                  this.visible = false;
                  this.formReset();
                  // 更新列表
                  this.updateList();
                } else {
                  this.formError = res.message;
                  this.$refs.formError.scrollIntoView(true);
                }
              })
              .finally(() => {
                this.formLoading = false;
              });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // error reset
    formInput() {
      this.formError = '';
    },
    // add form reset
    formReset() {
      this.$refs.formElement.resetFields();
      Object.keys(this.form).forEach(key => {
        this.form[key] = undefined;
      });
    },

    dataRangeValidator(rule, value, callback) {
      if (trim(value)) {
        if (this.currentItemType && this.currentItemType.rangeValidator) {
          const validateText = this.currentItemType.rangeValidator(value);
          if (validateText !== true) {
            callback(validateText);
          } else {
            callback();
          }
        }
      }
      callback();
    },

    itemTypeChange(value, edit) {
      this.currentItemType = this.itemTypes.find(item => item.value === value);
      if (!edit) {
        this.form.dataRange = '';
      }
    },
  },
};
</script>
<style lang="less" scoped>
.form-error-text {
  height: 25px;
  line-height: 25px;
  color: #f00;
  display: flex;
  align-items: center;
  p {
    margin: 0 0 0 10px;
    padding: 0;
  }
}
</style>
